import React, { useState, useEffect, Fragment } from 'react';
//import { s3ListObjects, s3ReadFile, s3WriteFile, s3DeleteFile } from '../components/s3Utils';
import { s3ReadFile, s3ListObjects, s3WriteFile } from '../components/s3Utils';
import { Button, useAuthenticator, Text } from '@aws-amplify/ui-react';
import { Offcanvas, Container } from 'react-bootstrap';
import { MdSave, MdDoneOutline } from 'react-icons/md'
// import background from '../components/assets/table-2879213_1920.jpg';
import Footer from '../components/lib/Footer';
import { Navigate } from 'react-router-dom';
import { Introduction, Loading, RehazieleCard1, RehazieleCard2 } from '../components/rehaziele/index';


const Rehaziele = () => {
    const { user } = useAuthenticator((context) => [context.user]);
    const [rehaziele, setRehaziele] = useState();
    const [rehazieleStamm, setRehazieleStamm] = useState();
    const [thzielevalues, setThzieleValues] = useState()
    const [sticky, setSticky] = useState(undefined);
    const [show, setShow] = useState(false);
    const [saved, setSaved] = useState(null);
    const filename = "Rehaziele.json";
    const filenameOfStamm = "RehazieleStamm.json";
    const hook1 = rehazieleStamm && rehazieleStamm.filter(f => f.KUERZEL === 'AWS1').length === 1 ? rehazieleStamm.filter(f => f.KUERZEL === 'AWS1')[0].ID : 0;
    const hook2 = rehazieleStamm && rehazieleStamm.filter(f => f.KUERZEL === 'AWS2').length === 1 ? rehazieleStamm.filter(f => f.KUERZEL === 'AWS2')[0].ID : 0;


    // console.log('Einverstaendnis')

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const showFooter = false;


    //    useBlocker("Are you sure you want to leave?", sticky);   // wait for version 6 is completed and useBlocker back

    useEffect(() => {
        window.onbeforeunload = function () {
            if (sticky) {
                return "Sie haben nicht gespeicherte Änderungen?";
            }
        };
    }, [sticky]);

    function handleChange(value) {
        // console.log(value);
        let newRehaZiele = rehaziele;
        const toChange = newRehaZiele.filter(f => (f.ID === value.ID && f.STAMMID === value.STAMMID));
        if (toChange.length > 0) {
            newRehaZiele = [...newRehaZiele.filter(f => !(f.ID === value.ID && f.STAMMID === value.STAMMID)), value];
        } else {
            newRehaZiele = [...newRehaZiele, value];
        }
        setRehaziele(newRehaZiele);
        setSticky(true);
    }

    const storeRehazielestamm = (data) => {
        // console.log('storeRehazielestamm:', data.hasOwnProperty("REHAZIELESTAMM") ? data["REHAZIELESTAMM"] : [])
        setRehazieleStamm(data.hasOwnProperty("REHAZIELESTAMM") ? data["REHAZIELESTAMM"] : []);
        setThzieleValues(data.hasOwnProperty("THZIELEVALUES") ? data["THZIELEVALUES"] : []);
    }

    const storeRehaziele = (data) => {
        if (data.hasOwnProperty('REHAZIELE')) {
            const myData = data['REHAZIELE'];
            // console.log(myData)
            setRehaziele(myData);
        }
        else {
            // console.log('file not found')
            setRehaziele([]);
        }
        setSticky(false);
    }

    const handleS3Rehaziele = (result) => {
        const keys = Object.keys(result);
        if (keys.includes(filename)) {
            // console.log('keys', keys)
            s3ReadFile(filename, 'private', storeRehaziele)
        } else {
            storeRehaziele([])
        }
    }

    const handleSaveButton = (e) => {
        e.preventDefault();
        // console.log('Origin: ', origin);
        // console.log('rehaziele to be saved:', rehaziele);
        const toBeSaved = rehaziele;
        // console.log('Ergebnis:', toBeSaved);
        setRehaziele(toBeSaved);
        // console.log(user)
        s3WriteFile(filename, { 'REHAZIELE': toBeSaved, User: user.username, MASSNID: user.attributes['custom:kvsID'] }, "private", "text/plain");
        setSticky(false);
        setSaved(setTimeout(() => {
            setSaved(null);
        }, 1000))
    }

    useEffect(() => {

        if (!rehazieleStamm || rehazieleStamm.length < 1) {
            s3ReadFile(filenameOfStamm, 'public', storeRehazielestamm);
        }

        if (!rehaziele || rehaziele.length < 1) {
            // console.log('useEffect no daten')
            s3ListObjects('', 'private', handleS3Rehaziele);
        }
        return () => {
            setRehazieleStamm([])
            setRehaziele([])
            if (saved != null) {
                clearTimeout(saved);
                setSaved(null);
            }
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    // console.log('--> Daten... isLoaded=%s, values', isLoaded, daten)
    // console.log('Start-Date is:', values[0]['DATUM_VON'])

    // style={{ position: "sticky", top: 100, display: "flex", justifyContent: "flex-end" }}

    if (!user) {
        return (<Navigate to='/profile' replace={true} />)
    }

    /*
        if (!daten || daten.length  === undefined || daten.length === 0) {
            return null;
        }
    */
    // console.log('neu befüllte MenueWahlListe:', daten)
    // style={{
    //    backgroundImage: `url(${background})`,
    // }}
    return (
        <Container fluid >
            {!rehazieleStamm && <Loading loadingtext="Rehaziele Stammdaten" />}
            {!rehaziele && <Loading loadingtext="Rehaziele" />}
            {rehazieleStamm && rehaziele &&
                <>
                    <form onSubmit={handleSaveButton}>
                        <div
                            className="floating-div"
                            style={{
                                position: "fixed",
                                right: "10px",
                                display: "flex",
                                justifyContent: "flex-end",
                                gap: "0.5rem",
                                padding: "1rem",
                                zIndex: "50"
                            }}>
                            <Button style={{ backgroundColor: 'white'}} variant="light" onClick={handleShow}>Hilfe</Button>
                            {sticky &&
                                <Button
                                    size='large'
                                    gap="1rem"
                                    type="submit"
                                    variation="primary"
                                > <MdSave />&nbsp;Speichern</Button>
                            }
                            {saved && <Button
                                size='large'
                                gap="1rem"
                                variation="primary"
                            > <MdDoneOutline />&nbsp;gespeichert</Button>}
                        </div>
                        <Offcanvas show={show} onHide={handleClose}>
                            <Offcanvas.Header closeButton>
                                <Offcanvas.Title>Erläuterungen</Offcanvas.Title>
                            </Offcanvas.Header>
                            <Offcanvas.Body>
                                <p>Wir benötigen Ihre Ziele, um Ihre Reha optimal für Sie abzustimmen.</p>
                                <p>Die von Ihnen genannten Ziele werden in unserer Datenbank gespeichert und stehen damit den Ärzt*innen und Therapeut*innen zur Verfügung.</p>
                                <p>-----</p>
                                <p>Nach einer Änderung erscheint das Feld "Speichern"; vergessen Sie bitte nicht, Ihre Auswahl durch Anklicken zu speichern.</p>
                                <p></p>
                                <p>Die gespeicherten Änderungen werden ein mal täglich übernommen, weshalb sie auch erst am nächsten Tag für uns sichtbar sind.</p>
                            </Offcanvas.Body>
                        </Offcanvas>
                        <Introduction />
                        <RehazieleCard1
                            handleChange={handleChange}
                            rehazieleStamm={rehazieleStamm}
                            rehaziele={rehaziele}
                            hook={hook1}
                            readOnly={false}
                            key='dummy'
                        />
                        <Text>&nbsp;</Text>
                        <RehazieleCard2
                            handleChange={handleChange}
                            rehazieleStamm={rehazieleStamm}
                            thzielevalues={thzielevalues}
                            rehaziele={rehaziele}
                            hook={hook2}
                            readOnly={false}
                            key='next'
                        />

                        {sticky && showFooter &&
                            <Footer>
                                <Button
                                    size='large'
                                    gap="1rem"
                                    type="submit"
                                ><MdSave />Speichern</Button>
                            </Footer>
                        }
                    </form>
                </>
            }
        </Container>
    )
}

export default Rehaziele;